import { useCallback, useEffect, useRef, useState } from "react";
import { RotateCcw } from "lucide-react";
import { saveDraft, readDraft, clearDraft, draftAgeLabel } from "@/lib/planDraft";

// Respaldo local de un editor de planeación. Detecta un borrador sin guardar de una
// sesión anterior (cuando la planeación es NUEVA) y permite recuperarlo.
export function useDraftBackup({ tipo, initialId }) {
  const keyRef = useRef(`${tipo || "plan"}:${initialId || "new"}`);
  const [pending, setPending] = useState(null);
  const checked = useRef(false);

  useEffect(() => {
    if (checked.current) return;
    checked.current = true;
    if (!initialId) {
      const d = readDraft(keyRef.current);
      if (d) setPending(d);
    }
  }, [initialId]);

  const backup = useCallback((payload) => saveDraft(keyRef.current, payload), []);
  const clear = useCallback(() => clearDraft(keyRef.current), []);
  const dismiss = useCallback(() => { clearDraft(keyRef.current); setPending(null); }, []);
  const consumed = useCallback(() => setPending(null), []);

  return { pending, backup, clear, dismiss, consumed };
}

export function DraftRecoverBanner({ pending, onRecover, onDismiss }) {
  if (!pending) return null;
  return (
    <div className="mb-3 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 flex items-center gap-2 text-[12px] text-amber-800" data-testid="plan-draft-recover">
      <RotateCcw className="w-4 h-4 shrink-0" />
      <span className="flex-1">Se encontró un borrador sin guardar ({draftAgeLabel(pending._ts)}). ¿Recuperar tu trabajo?</span>
      <button onClick={onRecover} data-testid="plan-draft-recover-btn" className="font-semibold bg-amber-600 hover:bg-amber-700 text-white px-2.5 py-1 rounded-md shrink-0">Recuperar</button>
      <button onClick={onDismiss} data-testid="plan-draft-dismiss-btn" className="text-amber-700 hover:underline px-1.5 py-1 shrink-0">Descartar</button>
    </div>
  );
}
